import type {
  AppearanceAssetView,
  AppearanceRequirement,
  DynamicPrepView,
  OnboardingScript,
  PersonaView,
} from '@alterium/shared';
import { api } from './client';

export interface CaptureScriptResponse {
  script: OnboardingScript;
  duration: { minSec: number; targetSec: number; maxSec: number };
  instructions: string[];
}

export const personaApi = {
  get: () => api.get<PersonaView>('/persona'),
  captureScript: () => api.get<CaptureScriptResponse>('/persona/capture-script'),
  submitCapture: (assetId: string, scriptVersion?: string) =>
    api.post<PersonaView>('/persona/capture', {
      assetId,
      ...(scriptVersion ? { scriptVersion } : {}),
    }),
  appearance: () => api.get<AppearanceAssetView[]>('/persona/appearance'),

  /** §22: подготовка к динамичным сценам — что уже собрано. */
  dynamicPrep: () => api.get<DynamicPrepView>('/persona/dynamic-prep'),
  startDynamicPrep: (faceAssetId: string, bodyAssetId: string) =>
    api.post<PersonaView>('/persona/dynamic-prep', { faceAssetId, bodyAssetId }),

  requirements: (params: { fullBody?: boolean; halfBody?: boolean } = {}) =>
    api.get<AppearanceRequirement[]>(
      `/persona/appearance/requirements?fullBody=${params.fullBody ?? false}&halfBody=${params.halfBody ?? false}`,
    ),
};
